export const redirectLink = (haystack: string, needle: string) => {
    window.location.href = haystack
    // if (haystack.includes(needle)) {
    //     window.location.href = haystack
    // } else {
    //     window.open(haystack, '_blank')
    // }
}
